import { render, staticRenderFns } from "./__TemBaoOdd.vue?vue&type=template&id=94ed5dc4&"
import script from "./__TemBaoOdd.vue?vue&type=script&lang=js&"
export * from "./__TemBaoOdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports